/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CashCreditsProcessItemDto = {
    /**
     * Invoice id that currently holds unallocated credit
     */
    sourceInvoiceId?: string;
    /**
     * Client id for manual unallocated credit line item
     */
    sourceClientId?: string;
    action: CashCreditsProcessItemDto.action;
    /**
     * Required when action is ALLOCATE
     */
    allocationInvoiceId?: string;
    /**
     * Optional when action is REFUND, defaults to full available balance
     */
    refundAmount?: number;
    /**
     * Required when action is REFUND
     */
    refundRecipient?: CashCreditsProcessItemDto.refundRecipient;
};
export namespace CashCreditsProcessItemDto {
    export enum action {
        ALLOCATE = 'ALLOCATE',
        REFUND = 'REFUND',
    }
    /**
     * Required when action is REFUND
     */
    export enum refundRecipient {
        CLIENT = 'CLIENT',
        BUSINESS = 'BUSINESS',
        PREMIUM_FUNDER = 'PREMIUM_FUNDER',
    }
}

